import { useRecoilState } from "recoil";
import { ThemeLight } from "../state/ThemeLight";

const NotFound = () => {
  const [themeLight] = useRecoilState(ThemeLight);

  return (
    <div className="comingSoon">
      <img
        src={
          themeLight
            ? "/assets/img/logo_black.png"
            : "/assets/img/logo_white.png"
        }
        alt=""
      />
      <span className="title">Not Found!</span>
    </div>
  );
};

export default NotFound;
